export interface GroupStyles {
  border: string;
  background: string;
  labelBg: string;
  labelText: string;
}

/**
 * Get Tailwind CSS classes for logical filter groups based on nesting depth
 */
export function getGroupStyles(depth: number): GroupStyles {
  if (depth === 0) {
    return {
      border: 'border-blue-300',
      background: '',
      labelBg: 'bg-blue-100',
      labelText: 'text-blue-700',
    };
  }

  // Depth 1 (nested)
  return {
    border: 'border-purple-300',
    background: '',
    labelBg: 'bg-purple-100',
    labelText: 'text-purple-700',
  };
}
